"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1345],{

/***/ 41345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77058);
/* harmony import */ var _components_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52738);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85112);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9465);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);













var SubListCardView = function SubListCardView(props) {
  var _otherHomes$filter, _props$item2, _minBy, _minBy2, _minBy2$tag_size, _minBy2$tag_size$toSt;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  if (!props.item) return null;
  var isMobileVersion = props.isMobileVersion,
      category = props.category,
      title = props.title;
  var _props$item = props.item,
      id = _props$item.id,
      otherHomes = _props$item.otherHomes,
      companyHomes = _props$item.companyHomes;
  var totalAllString = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(category === _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? otherHomes === null || otherHomes === void 0 ? void 0 : (_otherHomes$filter = otherHomes.filter(function (i) {
    return i.id !== id;
  })) === null || _otherHomes$filter === void 0 ? void 0 : _otherHomes$filter.length : companyHomes === null || companyHomes === void 0 ? void 0 : companyHomes.length);
  var fromPriceString = category === _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .formatCurrency */ .xG)((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)((_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.tag_price)) : (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .formatCurrency */ .xG)((0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)((_minBy = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.minBy)(companyHomes, "tag_price")) === null || _minBy === void 0 ? void 0 : _minBy.tag_price));
  var fromSizeString = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)((_minBy2 = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.minBy)(companyHomes, "tag_size")) === null || _minBy2 === void 0 ? void 0 : (_minBy2$tag_size = _minBy2.tag_size) === null || _minBy2$tag_size === void 0 ? void 0 : (_minBy2$tag_size$toSt = _minBy2$tag_size.toString()) === null || _minBy2$tag_size$toSt === void 0 ? void 0 : _minBy2$tag_size$toSt.split(".")[0]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
    style: [styles.profileCardItemContainer, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
      style: [styles.rowContainer, {
        flex: 7
      }],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.tagTitle, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 12
        } : {}],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
          children: title
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.memberCountText, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 12
        } : {}],
        children: totalAllString
      })]
    }), (category === _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO || category === _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
      style: [styles.rowContainer, {
        flex: 8
      }],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.text, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 12
        } : {}],
        children: "From"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.grayText, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 12
        } : {},, {
          marginLeft: 4
        }],
        children: fromPriceString
      }), category !== _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
        style: styles.splitter
      }), category !== _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.text, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 12
        } : {}],
        children: "Min"
      }), category !== _config__WEBPACK_IMPORTED_MODULE_1__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_9___default()), {
        style: [styles.grayText, isMobileVersion ? {
          fontSize: 10,
          lineHeight: 12
        } : {},, {
          marginLeft: 4
        }],
        children: ["Min ", fromSizeString, " sqft"]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_2__/* .CImage */ .DW, {
        width: 18,
        height: 18,
        layout: "fixed",
        source: _config__WEBPACK_IMPORTED_MODULE_1__/* .Images.iconAngleRight */ .rU.iconAngleRight,
        style: styles.angleIcon,
        resizeMode: "contain"
      })
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10___default().create({
  profileCardItemContainer: {
    height: 70,
    alignSelf: "stretch",
    borderRadius: 25,
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-gray1"),
    marginHorizontal: 16,
    paddingHorizontal: 30,
    flexDirection: "row",
    alignItems: "center"
  },
  tagTitle: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: "white"
  },
  grayText: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2")
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  text: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: "white"
  },
  angleIcon: {
    width: 16,
    height: 16
  },
  memberCountText: {
    marginLeft: 12,
    fontSize: 18,
    lineHeight: 22,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryBold */ .F3.primaryBold,
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-gray2")
  },
  splitter: {
    width: 1,
    height: 16,
    borderRadius: 1,
    backgroundColor: _config__WEBPACK_IMPORTED_MODULE_1__/* .Colors.spliterLine */ .wL.spliterLine,
    marginHorizontal: 6
  }
});
/* harmony default export */ __webpack_exports__["default"] = (SubListCardView);

/***/ })

}]);